"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var TooltipIconButton_1 = __importDefault(require("./styledComponents/TooltipIconButton"));

var TooltipChildrenButton_1 = __importDefault(require("./styledComponents/TooltipChildrenButton"));

var TooltipContent_1 = __importDefault(require("./styledComponents/TooltipContent"));

var TooltipCharacter_1 = __importDefault(require("./styledComponents/TooltipCharacter"));

var TooltipIcon_1 = __importDefault(require("./styledComponents/TooltipIcon"));

var ClickLayer_1 = __importDefault(require("./styledComponents/ClickLayer"));

var ArrowIcon_1 = __importDefault(require("./styledComponents/ArrowIcon"));

var react_popper_1 = require("react-popper");

var Tooltip_meta_1 = require("./Tooltip.meta");

var mobx_1 = require("mobx");

var KeyboardKeys_1 = require("../../../shared/KeyboardKeys");

var Tooltip =
/** @class */
function (_super) {
  __extends(Tooltip, _super);

  function Tooltip(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Tooltip_meta_1.TOOLTIP_CATEGORY_KEY;
    _this.componentKey = Tooltip_meta_1.TOOLTIP_COMPONENT_KEY;
    _this.shown = false;

    _this.show = function () {
      _this.shown = true;
    };

    _this.hide = function () {
      _this.shown = false;
    };

    _this.onClick = function (e) {
      var _a = _this.props,
          _b = _a.preserveClickAction,
          preserveClickAction = _b === void 0 ? false : _b,
          _c = _a.trigger,
          trigger = _c === void 0 ? 'click' : _c;

      if (!preserveClickAction) {
        e.stopPropagation();
      }

      if (trigger === 'click') {
        _this.show();
      }
    };

    _this.onMouseEnter = function () {
      var _a = _this.props.trigger,
          trigger = _a === void 0 ? 'click' : _a;

      if (trigger === 'hover') {
        _this.show();
      }
    };

    _this.onMouseLeave = function () {
      var _a = _this.props.trigger,
          trigger = _a === void 0 ? 'click' : _a;

      if (trigger === 'hover') {
        _this.hide();
      }
    };

    _this.onBlur = function () {
      _this.hide();
    };

    return _this;
  }

  Tooltip.prototype.onKeyDown = function (evt) {
    if (evt.key === KeyboardKeys_1.KEYS.ESCAPE) {
      this.hide();
    }
  };

  Object.defineProperty(Tooltip.prototype, "tooltipButtonContent", {
    get: function get() {
      var character = this.props.character;

      if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(character)) {
        return react_1.default.createElement(TooltipCharacter_1.default, null, character);
      }

      return react_1.default.createElement(TooltipIcon_1.default, {
        asset: "base.tooltip.defaultIcon"
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Tooltip.prototype, "tooltipContent", {
    get: function get() {
      var _a = this.props.content,
          content = _a === void 0 ? '' : _a;
      return typeof content === 'string' ? react_1.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }) : content;
    },
    enumerable: true,
    configurable: true
  });

  Tooltip.prototype.getButton = function (ref) {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        buttonAccessibleText = _a.buttonAccessibleText;
    /**
     * Tab index of -1 is to allow the element to receive focus for the keyDown event to be triggered
     * This have been tested on Chrome, Safari, Opera, Edge, and IE as well (just for completeness)
     */

    return react_1.default.createElement("span", {
      ref: ref
    }, !ksys_app_template_1.utils.typeChecks.isNullOrUndefined(children) ? react_1.default.createElement(TooltipChildrenButton_1.default, {
      onClick: this.onClick,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onKeyDown: function onKeyDown(evt) {
        return _this.onKeyDown(evt);
      },
      onBlur: this.onBlur,
      "aria-label": buttonAccessibleText,
      role: "button",
      tabIndex: -1
    }, children) : react_1.default.createElement(TooltipIconButton_1.default, {
      onClick: this.onClick,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onKeyDown: function onKeyDown(evt) {
        return _this.onKeyDown(evt);
      },
      onBlur: this.onBlur,
      "aria-label": buttonAccessibleText,
      role: "button",
      tabIndex: -1
    }, this.tooltipButtonContent));
  };

  Tooltip.prototype.getContent = function (ref, style, placement, arrowProps) {
    var _a = this.props.showTooltipArrow,
        showTooltipArrow = _a === void 0 ? true : _a;
    return react_1.default.createElement("div", {
      "data-selector": "base-tooltip-tooltipContentWrapper",
      ref: ref,
      style: style,
      "data-placement": placement
    }, react_1.default.createElement(TooltipContent_1.default, {
      "aria-live": "polite"
    }, this.tooltipContent, showTooltipArrow && react_1.default.createElement("div", {
      "data-selector": "base-tooltip-arrowIconWrapper",
      ref: arrowProps.ref,
      style: arrowProps.style
    }, react_1.default.createElement(ArrowIcon_1.default, null))));
  };

  Object.defineProperty(Tooltip.prototype, "hasContent", {
    get: function get() {
      var _a = this.props.content,
          content = _a === void 0 ? '' : _a;
      return !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(content);
    },
    enumerable: true,
    configurable: true
  });

  Tooltip.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        _b = _a.position,
        position = _b === void 0 ? 'right' : _b,
        _c = _a.trigger,
        trigger = _c === void 0 ? 'click' : _c,
        _d = _a.fixedTooltip,
        fixedTooltip = _d === void 0 ? false : _d;

    if (!this.hasContent) {
      return null;
    }

    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(react_popper_1.Manager, null, this.shown && react_1.default.createElement(react_1.Fragment, null, trigger === 'click' && react_1.default.createElement(ClickLayer_1.default, {
      onClick: this.hide
    }), react_1.default.createElement(react_popper_1.Popper, {
      placement: position,
      positionFixed: fixedTooltip
    }, function (_a) {
      var ref = _a.ref,
          style = _a.style,
          placement = _a.placement,
          arrowProps = _a.arrowProps;
      return _this.getContent(ref, style, placement, arrowProps);
    })), react_1.default.createElement(react_popper_1.Reference, null, function (_a) {
      var ref = _a.ref;
      return _this.getButton(ref);
    })));
  };

  __decorate([mobx_1.observable], Tooltip.prototype, "shown", void 0);

  __decorate([mobx_1.action], Tooltip.prototype, "show", void 0);

  __decorate([mobx_1.action], Tooltip.prototype, "hide", void 0);

  __decorate([mobx_1.action], Tooltip.prototype, "onClick", void 0);

  __decorate([mobx_1.action], Tooltip.prototype, "onMouseEnter", void 0);

  __decorate([mobx_1.action], Tooltip.prototype, "onMouseLeave", void 0);

  __decorate([mobx_1.action], Tooltip.prototype, "onKeyDown", null);

  __decorate([mobx_1.action], Tooltip.prototype, "onBlur", void 0);

  __decorate([mobx_1.computed], Tooltip.prototype, "tooltipButtonContent", null);

  __decorate([mobx_1.computed], Tooltip.prototype, "tooltipContent", null);

  Tooltip = __decorate([mobx_react_1.observer], Tooltip);
  return Tooltip;
}(shared_1.ComponentBase);

exports.Tooltip = Tooltip;
exports.default = shared_1.InjectedStyledComponent(Tooltip, Tooltip_meta_1.TOOLTIP_CATEGORY_KEY, Tooltip_meta_1.TOOLTIP_COMPONENT_KEY);